import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { InstallerRoutingModule } from './installer-routing.module';
import { DashboardComponent } from './dashboard/dashboard.component';
import { NgxGaugeModule } from 'ngx-gauge';
import { GuageComponent } from 'src/app/ui_elements/guage/guage.component';
import { PhGuageComponent } from 'src/app/ui_elements/ph-guage/ph-guage.component';
import { TempGuageComponent } from 'src/app/ui_elements/temp-guage/temp-guage.component';
import { AcidConcGuageComponent } from 'src/app/ui_elements/acid-conc-guage/acid-conc-guage.component'; 
import { QrCodeModule } from 'ng-qrcode';
import { NgbModule, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { QrComponent } from './qr/qr.component';
import { SideBarComponent } from 'src/app/components/side-bar/side-bar.component';
import { CustomerDashboardComponent } from "./dashboard/customer-dashboard/customer-dashboard.component";

@NgModule({
    declarations: [
        DashboardComponent,
        GuageComponent,
        PhGuageComponent,
        TempGuageComponent,
        QrComponent,
        AcidConcGuageComponent
    ],
    imports: [
        CommonModule,
        InstallerRoutingModule,
        NgxGaugeModule,
        QrCodeModule,
        NgbModule,
        FormsModule,
        ReactiveFormsModule,
        NgbPopoverModule,
        SideBarComponent,
        CustomerDashboardComponent
]
})
export class InstallerModule { }
